module.exports = __webpack_public_path__ + "img/thumbnail_Nilgai_f_normal.cd8ab36e.png";